import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelDynamic as _vModelDynamic, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-16a23494"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "login-form" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Acesse", -1))
const _hoisted_3 = { class: "inputs-form" }
const _hoisted_4 = { class: "input-password" }
const _hoisted_5 = ["type"]
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Esqueci minha senha*")
const _hoisted_7 = { class: "buttons" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  class: "button button--sign-in",
  type: "submit"
}, "Entrar", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RegisterModal = _resolveComponent("RegisterModal")!
  const _component_ResetPassword = _resolveComponent("ResetPassword")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    ($setup.isSignupModalOpen)
      ? (_openBlock(), _createBlock(_component_RegisterModal, {
          key: 0,
          onToggleRegisterModal: $setup.onCloseSignup
        }, null, 8, ["onToggleRegisterModal"]))
      : _createCommentVNode("", true),
    (_ctx.$route.params.resetPass)
      ? (_openBlock(), _createBlock(_component_ResetPassword, {
          key: 1,
          class: "reset-pass",
          onToggleModal: $setup.onCloseForgetPassword
        }, null, 8, ["onToggleModal"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("form", {
        onSubmit: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => ($setup.onSubmit && $setup.onSubmit(...args)), ["prevent"])),
        class: "form--login"
      }, [
        _hoisted_2,
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_3, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              placeholder: "CPF ou e-mail",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.name) = $event))
            }, null, 512), [
              [_vModelText, $setup.name]
            ]),
            _createElementVNode("div", _hoisted_4, [
              _withDirectives(_createElementVNode("input", {
                type: $setup.isPasswordVisible ? 'text' : 'password',
                placeholder: "Senha",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.password) = $event))
              }, null, 8, _hoisted_5), [
                [_vModelDynamic, $setup.password]
              ]),
              _createElementVNode("span", {
                onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.togglePassword())),
                class: _normalizeClass(["input__visibility", $setup.isPasswordVisible ? '' : 'notVisible'])
              }, null, 2)
            ])
          ]),
          _createVNode(_component_router_link, {
            class: "link",
            to: { name: 'home', params: { resetPass: true } }
          }, {
            default: _withCtx(() => [
              _hoisted_6
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_7, [
            _hoisted_8,
            _createElementVNode("button", {
              class: "button button--sign-up",
              onClick: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => ($setup.onClickSignup && $setup.onClickSignup(...args)), ["prevent"]))
            }, " Cadastre-se ")
          ])
        ])
      ], 32)
    ])
  ], 64))
}